import { Modal, Result } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export interface SuccessModalProps {
  errorMsg;
}

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 16px;
  }
`;

const StyledResult = styled(Result)`
  .ant-result-title {
    font-size: 24px;
  }

  .ant-result-subtitle {
    font-size: 28px;
  }
`;

const ErrorModal: FC<SuccessModalProps> = ({ errorMsg }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  const closeModal = () => {
    setVisible(false);
  };

  useEffect(() => {
    if (errorMsg) {
      setVisible(true);
    }
  }, [errorMsg]);

  return visible ? (
    <StyledModal
      open={visible}
      footer={null}
      onCancel={closeModal}
      closable
      destroyOnClose
      centered
      className="w-5/6 md:w-4/6"
    >
      <div className="flex flex-col items-center justify-center p-0 md:p-24">
        <StyledResult status="error" title={t('booking.errorModal.title')} subTitle={errorMsg} />
      </div>
    </StyledModal>
  ) : null;
};

export default ErrorModal;
